













import { Component, Vue, Prop } from 'vue-property-decorator';
interface pageData {
  total: number;
  currentPage: number;
  size: number;
}
@Component
export default class Pagination extends Vue {
  // 接收参数
  @Prop() public page!: pageData;
  // 当前页 数量切换事件
  public handleSizeChange(e) {
    this.$emit('sizeChange', e);
  }
  // 当前第几页切换事件
  public handleCurrentChange(e) {
    this.$emit('currentPageChange', e);
  }
}
